import o from"graphology-layout/random";import{useLayoutFactory as a}from"@react-sigma/layout-core";const r=a(o,{});export{r as useLayoutRandom};
//# sourceMappingURL=react-sigma_layout-random.esm.min.js.map
